import { fontSize } from "@mui/system";
import React from "react";
import { Link } from "react-router-dom";

const PremiumButton = () => {
  return (
    <div
      style={{
        // height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Link to="/subscription" style={styles.button} className="shine-button">
        <span style={{ position: "relative", zIndex: 2 }}>Get premium</span>
        <span style={styles.shine}></span>
      </Link>

      <style>
        {`
          @keyframes slide {
            0% { transform: translateX(-100%); }
            100% { transform: translateX(100%); }
          }
        `}
      </style>
    </div>
  );
};

const styles = {
  button: {
    color: "black",
    backgroundImage: "linear-gradient(180deg, #f6e27a 20%, #cb9b51 80%)",
    fontWeight: "medium",
    padding: "12px 20px",
    borderRadius: "8px",
    margin: "5px",
    borderWidth: 0,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    textDecoration: "none",
    position: "relative",
    overflow: "hidden",
    flex: 1,
    fontSize: "16px",
  },
  shine: {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    height: "220px",
    width: "100%",
    zIndex: 1,
    background:
      "linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,0.8) 50%, rgba(128,186,232,0) 99%, rgba(125,185,232,0) 100%)",
    animation: "slide 2s infinite",
    transform: "translateX(-100%)",
  },
};

export default PremiumButton;
